const InfoCardPlaceholder = () => {
  return (
    <div className="animate-pulse">
      <div className="mx-auto mb-4 h-6 w-3/4 rounded bg-gray-200" />
      <div className="mx-auto h-[110px] w-full rounded bg-gray-200" />
      <div className="my-4 space-y-2">
        <div className="h-3 w-full rounded bg-gray-200" />
        <div className="h-3 w-5/6 rounded bg-gray-200" />
        <div className="h-3 w-4/6 rounded bg-gray-200" />
      </div>
      <div className="flex justify-center">
        <div className="h-9 w-24 rounded-full bg-gray-200" />
      </div>
    </div>
  );
};

export default InfoCardPlaceholder;
